/*
 * Lashthing landingspagina-secties (variant B "Kies je look"): onthulling bij scrollen (exact het voorbeeld),
 * carrousel-pijlen, klantvideo's (play/pause). Eén keer per pagina (window.__llBound); secties zetten zelf html.ll--js
 * zodat verborgen startstanden alleen met JS gelden. Contract: docs/CONTRACT.md (R2A A7, R2E).
 *
 * Drie onthullingen, gemeten op sassysaints.com (11-09-2026):
 *  - .ll-reveal      generiek: eenmalig, drempel 0,15, rootMargin -40 px, pre-pass voor wat al in beeld staat
 *  - .ll-reveal-row  tabelrijen: schuiven van links in, drempel 0,1, rootMargin -50 px, eenmalig
 *  - .ll-reveal-group kaart: eenmalig, drempel 0,1, rootMargin -50 px; kaart, beeld en teksten volgen getrapt (CSS)
 */
(function () {
  'use strict';
  if (window.__llBound) return;
  window.__llBound = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  document.documentElement.classList.add('ll--js');

  function addAll(root, sel, cls) {
    var items = (root || document).querySelectorAll(sel);
    for (var i = 0; i < items.length; i++) items[i].classList.add(cls);
  }

  var ioOnce = null, ioRows = null, ioGroups = null;
  function observe(root) {
    root = root || document;
    if (reduced || !hasIO) {
      addAll(root, '.ll-reveal', 'is-revealed');
      addAll(root, '.ll-reveal-row', 'is-visible');
      addAll(root, '.ll-reveal-group', 'is-visible');
      return;
    }
    // generiek: pre-pass voor alles wat bij laden al in beeld staat (geen flits van verborgen content boven de vouw)
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var once = root.querySelectorAll('.ll-reveal:not(.is-revealed)');
    for (var i = 0; i < once.length; i++) {
      var r = once[i].getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) once[i].classList.add('is-revealed');
    }
    if (!ioOnce) {
      ioOnce = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) { entries[k].target.classList.add('is-revealed'); ioOnce.unobserve(entries[k].target); }
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    once = root.querySelectorAll('.ll-reveal:not(.is-revealed)');
    for (var j = 0; j < once.length; j++) ioOnce.observe(once[j]);
    // tabelrijen: eenmalig inschuiven (het voorbeeld animeert opnieuw bij terugscrollen; eenmalig voorkomt lege rijen in
    // full-page captures en print, jury R2E)
    if (!ioRows) {
      ioRows = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) { entries[k].target.classList.add('is-visible'); ioRows.unobserve(entries[k].target); }
        }
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    }
    var rows = root.querySelectorAll('.ll-reveal-row:not([data-ll-observed])');
    for (var m = 0; m < rows.length; m++) { rows[m].setAttribute('data-ll-observed', ''); ioRows.observe(rows[m]); }
    // kaartgroepen: eenmalig
    if (!ioGroups) {
      ioGroups = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) { entries[k].target.classList.add('is-visible'); ioGroups.unobserve(entries[k].target); }
        }
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    }
    var groups = root.querySelectorAll('.ll-reveal-group:not(.is-visible)');
    for (var g = 0; g < groups.length; g++) ioGroups.observe(groups[g]);
  }
  observe(document);
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  // vangnet: wat na 6 s nog verborgen is maar wel in beeld staat (bv. print), zichtbaar maken
  window.addEventListener('load', function () { setTimeout(function () {
    var vh = window.innerHeight;
    var items = document.querySelectorAll('.ll-reveal:not(.is-revealed), .ll-reveal-group:not(.is-visible)');
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) items[i].classList.add(items[i].classList.contains('ll-reveal') ? 'is-revealed' : 'is-visible');
    }
  }, 6000); }, { once: true });

  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-ll-play]');
    if (play) {
      var card = play.closest('.ll-videos__card');
      var v = card && card.querySelector('video');
      if (!v) return;
      var root = play.closest('.ll');
      if (root) root.querySelectorAll('video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      card.classList.add('is-playing');
      v.setAttribute('controls', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () { card.classList.remove('is-playing'); });
      return;
    }
    // Prijsoverzicht (14-09): de knop zet de keuze in de configurator bovenaan en scrolt daarheen,
    // zodat er maar één plek is waar de winkelwagen wordt gevuld.
    var pick = e.target.closest('[data-plan-pick]');
    if (pick) {
      var key = pick.getAttribute('data-plan-pick');
      var cfg = document.querySelector('lash-configurator');
      var radio = cfg && cfg.querySelector('input[data-set][value="' + key + '"]');
      if (radio) {
        if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        // 14-09 (opdracht Thomas): niet naar de bovenkant van de configurator maar naar "Kies je stijl",
        // zodat je meteen je wimper kiest in plaats van eerst terug te moeten scrollen.
        var doel = cfg.querySelector('.lc__group--style') || cfg;
        var top = doel.getBoundingClientRect().top + window.pageYOffset - 90;
        try { window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' }); } catch (err) { doel.scrollIntoView(); }
        var box = cfg.querySelector('[data-set-label="' + key + '"]');
        if (box) { box.classList.add('is-flash'); setTimeout(function () { box.classList.remove('is-flash'); }, 1200); }
      }
      return;
    }
    var prev = e.target.closest('[data-ll-prev]');
    var next = e.target.closest('[data-ll-next]');
    if (prev || next) {
      var sec = (prev || next).closest('.ll');
      var track = sec && sec.querySelector('[data-ll-track]');
      if (!track) return;
      var c = track.querySelector('.ll__card, .ll-videos__card, .ll-gallery__item');
      var step = c ? c.getBoundingClientRect().width + 12 : track.clientWidth;
      try { track.scrollBy({ left: prev ? -step : step, behavior: reduced ? 'auto' : 'smooth' }); } catch (err) { track.scrollLeft += prev ? -step : step; }
    }
  });
  // Garantievenster (opdracht Thomas 14-09): een antwoord in de FAQ linkt naar #garantie. Die klik vangen we op en
  // openen een klein venster met de uitleg, in plaats van naar een anker of pagina te springen. Bestaat het venster
  // niet (uitleg leeg gelaten in de theme editor), dan laten we de link gewoon zijn werk doen.
  // de chatbubbel wordt via CSS weggezet zolang html.ll-guar-open staat: zo werkt het ook als die bubbel pas
  // later inlaadt, wat met een eenmalige JS-aanpassing juist misgaat
  function guarSluit() {
    var box = document.querySelector('[data-guar]');
    if (!box || box.hidden) return;
    box.hidden = true;
    document.documentElement.classList.remove('ll-guar-open');
    if (guarOpener && guarOpener.focus) guarOpener.focus();
    guarOpener = null;
  }
  var guarOpener = null;
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href$="#garantie"]');
    if (link) {
      var box = document.querySelector('[data-guar]');
      if (!box) return;
      e.preventDefault();
      guarOpener = link;
      box.hidden = false;
      document.documentElement.classList.add('ll-guar-open');
      var sluit = box.querySelector('[data-guar-close]');
      if (sluit && sluit.focus) sluit.focus();
      return;
    }
    if (e.target.closest && e.target.closest('[data-guar-close]')) { e.preventDefault(); guarSluit(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') guarSluit(); });

  // media-events bubbelen niet: capture-fase op document
  document.addEventListener('play', function (e) { var c = e.target.closest && e.target.closest('.ll-videos__card'); if (c) c.classList.add('is-playing'); }, true);
  document.addEventListener('pause', function (e) { var c = e.target.closest && e.target.closest('.ll-videos__card'); if (c) c.classList.remove('is-playing'); }, true);
})();
